import { createContext } from "react";

const SessionContext = createContext(undefined as any);

export default SessionContext;
